export function resolveReviewTitle(review) {
  let noTitle = true;
  if (review.title && review.body) {
    noTitle = review.body.startsWith(review.title.split("...")[0]);
  }

  if (noTitle) {
    return "";
  }

  return review.title;
}
